// extracted by mini-css-extract-plugin
export var numberInputContainer = "_67-0";
export var startPickingButton = "_67-1";